"use strict";
/**
 * @copyright 2020 Microsoft Corporation
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    Globalize.addCultureInfo("en", {
        messages: {
            WhatsNew_DefaultTitle: "Whats new",
            WhatsNew_GotItButton: "Got it!",
            WhatsNew_LinkButton: "Learn more",
            WhatsNew_ShortCutDescription: "Move to the next feature callout",
        }
    });
    /**
     * A window that can be used to show "whats new context"
     * @internal
     */
    var whatsNew;
    (function (whatsNew) {
        whatsNew._whatsNewNotification = [];
        whatsNew._tipClass = {};
        whatsNew._currentFocusTip = 0;
        whatsNew.keyIds = {
            keyProperty: "gotit",
            keyStartPhrase: "whatsNewTip-",
            mainId: "WhatsNew_FeatureIntroduction",
            navigationKey: "NavPaneFirstUse",
        };
        /**
         * handles adding notificatoins to the whats new system
         * @internal
         * @param notification The notification object to process
         * @param options Any special qtip options to use
         */
        function processWhatsNewMessage(notification, options) {
            var e_1, _a;
            // we need to make sure we are not adding a duplicate (some interactions can send the same message multiple times)
            if ($dyn.whatsNew._whatsNewNotification) {
                try {
                    for (var _b = __values($dyn.whatsNew._whatsNewNotification), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var whatsNewNotification = _c.value;
                        if (whatsNewNotification.RuleId === notification.RuleId) {
                            $dyn.logWarning("Duplicate whatsnew messages detected skipping");
                            return;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            $dyn.whatsNew._whatsNewNotification.push(notification);
            $dyn.whatsNew._whatsNewOptions = options;
            $dyn.observe($dyn.clientBusy, function (isBusy) {
                var e_2, _a;
                if (!$dyn.value(isBusy)) {
                    var rootForm = "";
                    var tipId_1 = null;
                    // if recording or playback dont show whatsnew
                    if (($dyn.ax.taskRecording === undefined)
                        || (!$dyn.value($dyn.ax.taskRecording.isRecording)
                            && !$dyn.value($dyn.ax.taskRecording.taskGuidePlaybackState)
                            && !$dyn.value($dyn.ax.personalizationUtil.isPersonalizationModeTurnedOn()))) {
                        if ($dyn.whatsNew._whatsNewNotification) {
                            var _loop_1 = function (whatsNewNotification) {
                                rootForm = "";
                                var target = void 0;
                                var whatsNewData = [];
                                // Build up the whats new html and controls
                                // make sure this is for notifications and has data correctly set
                                if (whatsNewNotification.AdditionalData
                                    && whatsNewNotification.AdditionalDataType
                                    && whatsNewNotification.AdditionalDataType === "WhatsNewFeatureContract") {
                                    // additional data - [0] = url link
                                    whatsNewData = JSON.parse(whatsNewNotification.AdditionalData);
                                }
                                // did we get a full element or just the name
                                if (whatsNewNotification.TargetControl) {
                                    if (typeof whatsNewNotification.TargetControl === "string") {
                                        target = $($dyn.shell.activeFormElement).find("[data-dyn-controlname=" + whatsNewNotification.TargetControl + "]")[0];
                                    }
                                    else {
                                        target = whatsNewNotification.TargetControl;
                                    }
                                }
                                if ((!target && (whatsNewNotification.TargetControl === "" || whatsNewNotification.TargetControl === null)) || target) {
                                    // we didnt found a control or it is special case blank = put buy navbar
                                    if (!target) {
                                        // we got a blank tag - that means put next to navbar place by the dashboard button
                                        if ($dyn.isEmbedded) {
                                            target = $("[data-dyn-controlname=EmbeddedBar]")[0];
                                        }
                                        else if ($dyn.restrictedNavigation) {
                                            target = $("[data-dyn-controlname=PopoutNavigationBar]")[0];
                                        }
                                        else {
                                            target = $("[data-dyn-controlname=NavigationBar]")[0];
                                        }
                                        $dyn.whatsNew._whatsNewOptions = { my: "top center", at: "bottom center" };
                                    }
                                    // does the target have a rootForm - not all do
                                    if (typeof target !== "string") {
                                        if ($dyn.context(target) && $dyn.context(target).Root && $dyn.context(target).Root.FormName) {
                                            rootForm = $dyn.context(target).Root.FormName + "-";
                                        }
                                    }
                                    var optionsWhatsNew = null;
                                    if (!$dyn.whatsNew._whatsNewOptions) {
                                        optionsWhatsNew = !$dyn.util.isRTLMode() ? { my: "left center", at: "right center" } : { my: "right center", at: "left center" };
                                    }
                                    else {
                                        optionsWhatsNew = $dyn.whatsNew._whatsNewOptions;
                                    }
                                    // always add a "got it" button to the message
                                    var ruleId_1 = whatsNewNotification.RuleId;
                                    tipId_1 = rootForm + $dyn.whatsNew.keyIds.keyStartPhrase + ruleId_1;
                                    // build whatsnew html/controls
                                    var bodyContainer = $dyn.ui.createControl("Label", { Text: whatsNewNotification.Message }, null, "span");
                                    var actionGroup = $dyn.ui.createControl("Group", { Name: "WhatsNewButtonGroup" });
                                    if (whatsNewData[0] !== undefined && whatsNewData[0] !== "") {
                                        var linkControl = $dyn.ui.createChildControl("HyperLink", {
                                            BaseUrl: whatsNewData[0],
                                            OpenInNewWindow: true,
                                            Text: $dyn.label("WhatsNew_LinkButton"),
                                        }, actionGroup, { tagName: "a" });
                                        linkControl.classList.add("whatsNew-LinkControl");
                                    }
                                    // create the got it button
                                    var buttonContent = $dyn.ui.createChildControl("Button", {
                                        Click: function () { $dyn.whatsNew._whatsNewGotIt(tipId_1, ruleId_1); },
                                        Label: $dyn.label("WhatsNew_GotItButton"),
                                    }, actionGroup, { tagName: "button" });
                                    buttonContent.classList.add("whatsNew-GotItButton");
                                    // see if the one we want to show is open already
                                    if (!$dyn.whatsNew.isItShown(tipId_1)) {
                                        $dyn.whatsNew.openWhatsNew(target, tipId_1, whatsNewNotification.Title, $(bodyContainer).add($(actionGroup)), optionsWhatsNew);
                                    }
                                    else {
                                        // since it exists just reposition
                                        $dyn.whatsNew.reposition(tipId_1, true);
                                    }
                                }
                            };
                            try {
                                for (var _b = __values($dyn.whatsNew._whatsNewNotification), _c = _b.next(); !_c.done; _c = _b.next()) {
                                    var whatsNewNotification = _c.value;
                                    _loop_1(whatsNewNotification);
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                        }
                        // no notifications so clear it out
                        $dyn.whatsNew._whatsNewNotification = [];
                    }
                    return false;
                }
            });
        }
        whatsNew.processWhatsNewMessage = processWhatsNewMessage;
        /**
         * handles the click event and closes tip
         * @internal
         * @param _tipId The id fo the tip.
         * @param _ruleId The id fo the tip from xpp.
         */
        function _whatsNewGotIt(_tipId, _ruleId) {
            if (_ruleId === $dyn.whatsNew.keyIds.navigationKey) {
                $dyn.DynReact.ModuleStore.whatsNewClose();
            }
            else {
                // this is a generic whats new so we need to communicate back the got it value
                $dyn.async(function () {
                    $dyn.callFunction($dyn.user().SetCustomObjectPersonalization, undefined, [$dyn.whatsNew.keyIds.mainId, _ruleId, $dyn.whatsNew.keyIds.keyProperty, true]);
                }, undefined, "Update whatsnew gotit");
            }
            $dyn.whatsNew.closeWhatsNew(_tipId);
        }
        whatsNew._whatsNewGotIt = _whatsNewGotIt;
        /**
         * escape sequence special charcters
         * @internal
         * @param _id The id fo the tip.
         * @returns _id the id escaped.
         */
        function _escapedId(_id) {
            return _id ? _id.replace(/(:|\.|\{|\}|,|=|@)/g, "\\$1") : _id;
        }
        whatsNew._escapedId = _escapedId;
        /**
         * checks if we think any whatsnew are displayed/created
         * @internal
         * @returns true if found, false if not
         */
        function areWhatsNewShown() {
            return Object.keys($dyn.whatsNew._tipClass).length > 0 ? true : false;
        }
        whatsNew.areWhatsNewShown = areWhatsNewShown;
        /**
         * checks if a specific whatsnew tips is shown
         * @internal
         * @param _id The id fo the tip.
         * @returns true if found, false if not
         */
        function isItShown(_id) {
            if ($dyn.whatsNew._tipClass) {
                var $jTip = $dyn.whatsNew._tipClass[_id];
                if ($jTip && $jTip.qtip) {
                    return true;
                }
                // check if it is orphaned in the dom
                var tipId = $dyn.whatsNew._escapedId(_id);
                if ($("[id=qtip-" + tipId + "]")[0]) {
                    // remove it
                    $("[id=qtip-" + tipId + "]")[0].remove();
                    if ($jTip) {
                        delete $dyn.whatsNew._tipClass[_id];
                    }
                }
            }
            return false;
        }
        whatsNew.isItShown = isItShown;
        /**
         * Moves to the next visible whatsNew dialog and sets keyboard focus to first element
         * @internal
         */
        function moveNextWhatsNewFocus() {
            var keysArray = Object.keys($dyn.whatsNew._tipClass);
            if (keysArray) {
                // apply focus to the next whatsNew dialog
                $dyn.whatsNew._currentFocusTip = ((keysArray.length) > $dyn.whatsNew._currentFocusTip) ? $dyn.whatsNew._currentFocusTip : 0;
                var tipId = $dyn.whatsNew._escapedId(keysArray[$dyn.whatsNew._currentFocusTip]);
                if (tipId) {
                    // the tipId includes form name, we dont have form name on the
                    var tipElement = $("[id=qtip-" + tipId + "] > .qtip-titlebar")[0];
                    if (tipElement) {
                        tipElement.focus();
                        $dyn.whatsNew._currentFocusTip++;
                    }
                    else {
                        // found a tip that does not exist
                        // this can happen if you try to add qtip to a element that already has qtip (infrequent)
                        delete $dyn.whatsNew._tipClass[keysArray[$dyn.whatsNew._currentFocusTip]];
                    }
                }
                else {
                    $dyn.whatsNew._currentFocusTip = 0;
                }
            }
        }
        whatsNew.moveNextWhatsNewFocus = moveNextWhatsNewFocus;
        /**
         * closes any whatsNew for the given form
         * @internal
         * @param rootName Name of form to check for whatsNews and close down
         */
        function closeTipsForForm(rootName) {
            var $jTip;
            if ($dyn.whatsNew._tipClass) {
                for (var key in $dyn.whatsNew._tipClass) {
                    if ($dyn.whatsNew._tipClass.hasOwnProperty(key)) {
                        // does the rootName match the start of the key name
                        if (key.indexOf(rootName + "-") === 0) {
                            $jTip = $dyn.whatsNew._tipClass[key];
                            if ($jTip) {
                                $jTip.qtip("destroy", true);
                                delete $dyn.whatsNew._tipClass[key];
                            }
                        }
                    }
                }
            }
        }
        whatsNew.closeTipsForForm = closeTipsForForm;
        /**
         * Cleans up any tip that is passed in
         * @internal
         * @param _id The id of the tip.
         */
        function closeWhatsNew(_id) {
            if (Object.keys($dyn.whatsNew._tipClass).length > 0) {
                if (_id === $dyn.whatsNew.keyIds.navigationKey) {
                    _id = $dyn.whatsNew.keyIds.keyStartPhrase + _id;
                }
                var $jTip = $dyn.whatsNew._tipClass[_id];
                if ($jTip && $jTip.qtip) {
                    delete $dyn.whatsNew._tipClass[_id];
                    $jTip.qtip("destroy", true);
                }
                // now return focus
                var activeForm_1 = $dyn.context($dyn.shell.getActiveForm());
                if (activeForm_1) {
                    $dyn.log.focus && $dyn.log.focus("Focus: closeWhatsNew Form(Form.Id: %s) setting focus back to the active form", _id);
                    activeForm_1.takeNavigationFocus();
                }
            }
        }
        whatsNew.closeWhatsNew = closeWhatsNew;
        /**
         * repositions the whatsNew tip
         * @internal
         * @param _id The id of the tip.
         * @param _skipHide should we skip hide/show
         */
        function reposition(_id, _skipHide) {
            if (_skipHide === void 0) { _skipHide = false; }
            // first see if the tip exists with no form name (ie: it is not a form tied tip)
            var $jTip = $dyn.whatsNew._tipClass[_id];
            if ($jTip && $jTip.qtip) {
                $jTip.qtip("reposition");
                // if we are not autohiding and we are a "form named qtip"
                if (!_skipHide && (_id.indexOf && _id.indexOf("whatsNew-") !== 0)) {
                    // wait until render has completed to see if we need to hide or show it
                    $dyn.observe($dyn.clientBusy, function (isBusy) {
                        if (!isBusy) {
                            var escId = $dyn.whatsNew._escapedId(_id);
                            var bHidden = $dyn.util.isBehindOtherElement($jTip[0], $("[id=qtip-" + escId + "] > .qtip-tip canvas")[0]);
                            var jqElementToHide = $("[id=qtip-" + escId + "]");
                            if (bHidden && jqElementToHide.is(":visible")) {
                                jqElementToHide.hide();
                            }
                            else {
                                if (!bHidden && jqElementToHide.is(":hidden")) {
                                    jqElementToHide.show();
                                }
                            }
                            return false;
                        }
                    });
                }
            }
        }
        whatsNew.reposition = reposition;
        /**
         * hide the whatsNew tip if off screen
         * @internal
         * @param _id The id of the tip.
         */
        function hideIfScrolledOffView(_id) {
            if ($dyn.whatsNew._tipClass[_id] && !$dyn.util.isElementInView($dyn.whatsNew._tipClass[_id][0])) {
                var escId = $dyn.whatsNew._escapedId(_id);
                $("[id=qtip-" + escId + "]").hide();
            }
        }
        whatsNew.hideIfScrolledOffView = hideIfScrolledOffView;
        /**
         * Will gather data to send to whatsNew generator.
         * @internal
         *
         * @param _popByElement The dom element to place next to.
         * @param _id The id for the tip.
         * @param _captionText The label for the title.
         * @param _bodyContent The dom element for internal content to the whatsNew box.
         * @param _tipOptions The options to set the location, size, ect..
         */
        function openWhatsNew(_popByElement, _id, _captionText, _bodyContent, _tipOptions) {
            var tipDefault = {
                corner: true,
                height: 7,
                width: 15,
            };
            var classList = "whatsNew qtip-light baseDirection";
            var navBar = $dyn.ui.getNavBar();
            if (navBar && !$dyn.restrictedNavigation && $dyn.value(navBar.OfficeNavBarVisible())) {
                classList += " officeNavBarInUse";
            }
            try {
                // tslint:disable:object-literal-sort-keys
                $(_popByElement).qtip({
                    id: _id,
                    content: {
                        text: _bodyContent,
                        title: _captionText ? _captionText : $dyn.label("WhatsNew_DefaultTitle"),
                    },
                    show: {
                        delay: $dyn.flags.disableAnimations ? 0 : 500,
                        ready: true,
                        effect: $dyn.flags.disableAnimations ? false : undefined,
                    },
                    position: {
                        my: (_tipOptions && _tipOptions.my !== undefined) ? _tipOptions.my : "right center",
                        at: (_tipOptions && _tipOptions.at !== undefined) ? _tipOptions.at : "left center",
                        adjust: {
                            y: (_tipOptions && _tipOptions.adjust_y !== undefined) ? _tipOptions.adjust_y : 0,
                            x: (_tipOptions && _tipOptions.adjust_x !== undefined) ? _tipOptions.adjust_x : 0,
                            method: "shift shift"
                        },
                        viewport: $(window),
                        effect: $dyn.flags.disableAnimations ? false : undefined,
                    },
                    style: {
                        classes: classList,
                        tip: tipDefault
                    },
                    hide: {
                        event: _popByElement !== $("[data-dyn-controlname=NavigationBar]")[0] ? "click" : false,
                        effect: $dyn.flags.disableAnimations ? false : undefined,
                    },
                    events: {
                        render: function (event, api) {
                            // register listners for scroll, tabbing and layoutsize changes
                            $dyn.whatsNew.scrollingHandlerDispose = $dyn.util.scrollingContainer(api.elements.target[0], "" + api.id, $dyn.whatsNew.reposition);
                            $dyn.whatsNew.tabbingHandlerDispose = $dyn.util.tabbingContainer(api.tooltip[0], $dyn.label("whatsNew"));
                            $dyn.whatsNew.layoutReflowEndHandler = $dyn.layout.registerEndReflowHandler(api.elements.target[0], function () {
                                if (api.target[0].id === "NavBar" || api.target[0].id === "PopoutNavBar") {
                                    // if navbar we never want to autohide the qtip
                                    reposition(api.id, true);
                                }
                                else {
                                    reposition(api.id, false);
                                }
                            });
                            $(document.body).on("resetShellOnNavigation.whatsNew", function () {
                                var currentForm = $dyn.context($dyn.shell.getCurrentRootForm());
                                if (currentForm) {
                                    $dyn.whatsNew.closeTipsForForm(currentForm._formName);
                                }
                            });
                            // register keydown
                            $(document.body).on("keydown.whatsNewEsc", function (keyBoardEvent) {
                                if (keyBoardEvent.keyCode === $dyn.ui.KeyCodes.esc) {
                                    // we only want to close the one we have focus in - not all
                                    if ($(keyBoardEvent.target).closest(".whatsNew")[0]) {
                                        // grab just the id starting with whatsNew(ie: strip off qtip)
                                        var parsedId = $(keyBoardEvent.target).closest(".whatsNew")[0].id;
                                        parsedId = parsedId.startsWith("qtip-") ? parsedId.substr(5) : parsedId;
                                        keyBoardEvent.stopPropagation();
                                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Escape handler for qtip");
                                        keyBoardEvent.preventDefault();
                                        $dyn.whatsNew.closeWhatsNew(parsedId);
                                    }
                                }
                            });
                            // add Tab Stops
                            var escId = $dyn.whatsNew._escapedId(_id);
                            // add tabindex to title, content and button
                            var elem = $("[id=qtip-" + escId + "] > .qtip-titlebar")[0];
                            $(elem).attr("tabindex", "0");
                            elem = $("[id=qtip-" + escId + "] > .qtip-content")[0];
                            $(elem).attr("tabindex", "0");
                            // add item to the list
                            $dyn.whatsNew._tipClass[api.id] = api.elements.target;
                            setTimeout(function () {
                                $dyn.whatsNew.hideIfScrolledOffView(api.id);
                            });
                        },
                        focus: function (event, api) {
                            event.preventDefault(); // prevents other qtips from dismissing
                        },
                        hide: function (event, api) {
                            $dyn.whatsNew.scrollingHandlerDispose();
                            $dyn.whatsNew.tabbingHandlerDispose();
                            $(document.body).off("keydown.whatsNewEsc");
                            if ($dyn.whatsNew.layoutReflowEndHandler) {
                                $dyn.whatsNew.layoutReflowEndHandler.dispose();
                                $dyn.whatsNew.layoutReflowEndHandler = null;
                            }
                            $(document.body).off("resetShellOnNavigation.whatsNew");
                            $dyn.whatsNew.closeWhatsNew(api.id);
                        },
                    },
                }).qtip("api");
                // tslint:enable:object-literal-sort-keys
            }
            catch (error) {
                $dyn.async.pending.decrement("Done with WhatsNewTips load");
                $dyn.telemetry.addErrorEvent({ errorLabel: $dyn.label("WhatsNewTip"), callStack: error.stack, type: 3 });
            }
        }
        whatsNew.openWhatsNew = openWhatsNew;
    })(whatsNew = $dyn.whatsNew || ($dyn.whatsNew = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=WhatsNew.js.map
